<template>
    <div
        class="h-100"
        v-tinymce="options"
        :key="renderKey"
        @mce-change="(address) => offerSectionSet({ customerAddress: address })"
        @mce-dirty="() => $emit('dirty')"
    >
        <div
            v-if="offerSections.customerAddress"
            v-html="offerSections.customerAddress"
            class="h-100"
        ></div>
        <b-card
            v-else
            class="customer-address"
        >
            <h5>{{ $t('customerAddress.customerNumber', { number: customerId }) }}</h5>
            <div>{{ $t('customerAddress.offerNumber', { number: offer.offerNumber }) }}</div>
            <div>{{ $t('customerAddress.offerDate', { date: offerDate }) }}</div>
            <div class="mt-3"><b>{{ companyName }}</b></div>
            <span v-if="hasSecondaryName()">{{ company.company2 }}</span>
            <div>{{ customerName }}</div>
            <div>{{ customerStreet }}</div>
            <div>{{ customerLocation }}</div>
        </b-card>
    </div>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex';
import placeholder from './placeholder';
import { formatDate } from '../../misc/LocaleFormat';

export default {
    name: 'CustomerAddress',
    props: {
        options: Object,
    },
    mixins: [placeholder],
    data() {
        return {
            renderKey: 0,
        };
    },
    computed: {
        ...mapGetters([
            'offer',
            'company',
            'contact',
            'offerSections',
        ]),
        offerDate: function () {
            if (this.offer && this.offer.createdAt) {
                return formatDate(this.offer.createdAt, this.offer.language || 'de');
            }
            return this.placeholder;
        },
        customerId: function () {
            return this.company
                ? this.company.ref_id
                : this.placeholder;
        },
        companyName: function () {
            return this.company
                ? this.company.company
                : this.placeholder
        },
        customerName: function () {
            return this.contact
                ? this.contact.firstName
                    ? [
                        this.contact.firstName,
                        this.contact.lastName
                    ].join(' ')
                    : this.contact.lastName
                : this.placeholder;
        },
        customerStreet: function () {
            return this.company
                ? this.company.street
                : this.placeholder;
        },
        customerLocation: function () {
            return this.company
                ? this.company.zipCode
                    ? [
                        this.company.zipCode,
                        this.company.city
                    ].join(' ')
                    : this.company.city
                : this.placeholder;
        }
    },
    methods: {
        ...mapMutations(['offerSectionSet']),
        hasSecondaryName() {
            return (this.company && this.company.company2);
        }
    },
    watch: {
        company: function () {
            this.renderKey++;
        },
        contact: function () {
            this.renderKey++
        }
    }
}
</script>
